import { GetterTree } from "vuex";
import { IProcessTemplateState } from "@/store/modules/processTemplate/state";
import ProcessTemplate from "@/types/documents/process/ProcessTemplate";

import { IDataProvider, IRootState } from "@/store";

export enum ProcessTemplateGetters {
  GET_ALL = "GET_ALL_PROCESS_TEMPLATE",
  GET_CURRENT = "GET_CURRENT_PROCESS_TEMPLATE",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_PROCESS_TEMPLATE",
}

export const getters: GetterTree<IProcessTemplateState, IRootState> = {
  [ProcessTemplateGetters.GET_ALL](state): ProcessTemplate[] | null {
    return state.processTemplates;
  },
  [ProcessTemplateGetters.GET_CURRENT](state): ProcessTemplate | null {
    return state.processTemplate;
  },
  [ProcessTemplateGetters.GET_DATA_PROVIDER](
    state
  ): IDataProvider<ProcessTemplate> | null {
    return state.dataProvider;
  },
};
